import { animate, style, transition, trigger } from '@angular/animations';
import {
  Component,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  animations: [
    trigger('toggle', [
      transition('* => void', [style({ opacity: 0 }), animate(500)]),
    ]),
  ],
})
export class SuccessComponent implements OnInit, OnDestroy {
  @Input() label!: string;
  @Input() startAnimation = false;
  @Input() fullHeight = false;
  @Input() delay = 3000;
  @Output() nextPage = new EventEmitter();
  options: AnimationOptions = {
    path: './assets/animations/check.json',
    loop: false,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  timerId!: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    // tslint:disable
    this.timerId = setTimeout(() => {
      this.nextPage.emit();
    }, this.delay);
    // tslint:enable
  }

  ngOnDestroy(): void {
    clearTimeout(this.timerId);
  }
}
